import "./PrivacyPolicyScreenComponent.scss";
import BrandingComponent from "../branding/brandingComponent";

const PrivacyPolicyScreenComponent = () => {
    return (
        <div className="privacy-policy-screen-component">
            <div className="privacy-policy-header">
                <BrandingComponent sideMenuView={"default"}/>
            </div>
            <div className="privacy-policy-card">
                <div className="privacy-policy-card-header">
                    <div className="privacy-policy-card-header-title">
                        Data Privacy Policy
                    </div>
                    <div className="privacy-policy-card-header-description">
                        This Privacy Policy outlines AdvanzInnovation’s commitment to complying with the Health
                        Insurance Portability and Accountability Act (HIPAA) in its role as a Business Associate. It
                        defines the requirements for protecting Protected Health Information (PHI) and the
                        responsibilities of AdvanzInnovation when providing LIS software and related services to Covered
                        Entities.
                    </div>
                    <div className="privacy-policy-card-header-title">
                        Information Collection and Use
                    </div>
                    <span>

                        <span className={'privacy-policy-mini-header'}>Client Onboarding:</span>
                        <div className="privacy-policy-card-header-description">
                        During onboarding, AdvanzInnovation collects information such as client organization details,
                        authorized user information, and system requirements. This information is necessary to establish
                        accounts, configure services, and ensure seamless integration.
                        </div>
                    </span>
                    <div className={'margin-spacing'}/>
                    <span>
                        <span className={'privacy-policy-mini-header'}>Support Requests:</span>
                        <div className="privacy-policy-card-header-description">
                        When clients submit support requests, AdvanzInnovation collects relevant details, including user
                        contact information, system logs, and issue descriptions. This information is used solely to
                        resolve technical issues and improve services.
                        </div>
                    </span>
                    <div className={'margin-spacing'}/>
                    <span>
                        <span className={'privacy-policy-mini-header'}>Data Analytics:</span>
                        <div className="privacy-policy-card-header-description">
                        AdvanzInnovation collects and analyzes de-identified data sets to improve system performance,
                        enhance security, and develop new features. De-identified data complies with HIPAA’s Safe Harbor
                        or Expert Determination standards and cannot be re-identified.
                        </div>
                    </span>
                    <div className={'margin-spacing'}/>
                    <span>
                        <span className={'privacy-policy-mini-header'}>Logs and Audit Trails:</span>
                        <div className="privacy-policy-card-header-description">
                        AdvanzInnovation systems automatically generate logs recording user activity, data access, and
                        system changes. These logs are maintained to monitor compliance, ensure data integrity, and
                        support required auditing processes.
                        </div>
                    </span>
                    <div className={'margin-spacing'}/>
                    <span>
                        <span className={'privacy-policy-mini-header'}>Training and Compliance:</span>
                        <div className="privacy-policy-card-header-description">
                        AdvanzInnovation collects information related to training participation and compliance
                        certification for users accessing its systems. This ensures all personnel meet required privacy
                        and security standards.
                        </div>
                    </span>
                    <div className="privacy-policy-card-header-title">Permitted Uses and Disclosures</div>
                    <div className="privacy-policy-card-header-description">
                        AdvanzInnovation may use or disclose PHI only as permitted under HIPAA, including:
                        <ul>
                            <li>Treatment Purposes: Coordinating or managing health care services.</li>
                            <li>Healthcare Operations: Activities such as quality assessment, case management, or
                                administrative
                                operations.
                            </li>
                            <li>Billing and Payment Processing: Obtaining payment for services provided to clients.</li>
                            <li>As Required by Law: Disclosing PHI if mandated by federal or state law or court order.
                            </li>
                        </ul>
                        Additional permissible uses include public health and safety matters, research purposes, and
                        lawful
                        requests from medical examiners or law enforcement. Any use or disclosure outside these purposes
                        requires prior written authorization from the Covered Entity.
                    </div>

                    <div className="privacy-policy-card-header-title">Data Minimization</div>
                    <div className="privacy-policy-card-header-description">
                        AdvanzInnovation collects only the minimum necessary PHI required to fulfill contractual
                        obligations. This includes patient identifiers, test orders, laboratory results, and billing
                        information necessary for service delivery and compliance.
                    </div>
                    <div className="privacy-policy-card-header-title">De-identified Information</div>
                    <div className="privacy-policy-card-header-description">
                        De-identified data is utilized to improve AdvanzInnovation’s systems and technology. Such data
                        complies with HIPAA’s de-identification standards and is used solely for analytics, research,
                        and
                        service improvements. AdvanzInnovation ensures no identifiers are retained, and de-identified
                        data
                        cannot be re-identified.
                    </div>
                    <div className="privacy-policy-card-header-title">Incident and Breach Notification</div>
                    <div className="privacy-policy-card-header-description">
                        In the event of any unauthorized use or disclosure of PHI, AdvanzInnovation will promptly notify
                        the
                        Covered Entity within 72 hours of discovery. AdvanzInnovation will assist in mitigating
                        potential
                        harm, conducting investigations, and fulfilling HIPAA breach notification requirements.
                    </div>
                    <div className="privacy-policy-card-header-title">Subcontractors</div>
                    <div className="privacy-policy-card-header-description">
                        Any subcontractors engaged by AdvanzInnovation that may access PHI are required to:
                        <ul>
                            <li> Sign Business Associate Agreements (BAAs) that include HIPAA-compliant safeguards.</li>
                            <li>Undergo regular compliance monitoring to ensure adherence to standards. AdvanzInnovation
                                remains
                                responsible for the actions of its subcontractors regarding PHI.
                            </li>
                        </ul>
                    </div>
                    <div className="privacy-policy-card-header-title">Individual Rights</div>
                    <div className="privacy-policy-card-header-description">
                        AdvanzInnovation supports Covered Entities in fulfilling patient rights under HIPAA, including:
                        <ul>
                            <li>Accessing PHI: Providing records to patients upon request.</li>
                            <li>Amending PHI: Correcting inaccuracies in patient records.</li>
                            <li> Accounting of Disclosures: Tracking PHI-sharing activities.</li>
                        </ul>
                    </div>
                    <div className="privacy-policy-card-header-title">Retention and Disposal</div>
                    <div className="privacy-policy-card-header-description">
                        AdvanzInnovation retains PHI only as long as necessary to fulfill contractual obligations or
                        comply
                        with legal requirements. Upon termination of this agreement or at the request of the Covered
                        Entity,
                        PHI will be securely returned or destroyed using industry-standard methods.
                    </div>
                    <div className="privacy-policy-card-header-title">Data Security</div>
                    <div className="privacy-policy-card-header-description">
                        AdvanzInnovation implements industry-standard security measures to protect PHI, including:
                        <ul>
                            <li>Encryption: Encrypting PHI both in transit and at rest.</li>
                            <li> Access Controls: Restricting access to authorized personnel only.</li>
                            <li> Monitoring: Conducting regular audits and vulnerability assessments.</li>
                            <li> Compliance Frameworks: Adhering to NIST Cybersecurity Framework and HITRUST CSF.</li>
                        </ul>
                    </div>
                    <div className="privacy-policy-card-header-title">Notification of Changes</div>
                    <div className="privacy-policy-card-header-description">
                        This Privacy Policy is reviewed and updated annually or whenever HIPAA regulations change.
                        Covered
                        Entities will be notified promptly of significant updates.
                    </div>
                    <div className="privacy-policy-card-header-title">Contact Information</div>
                    <span className="privacy-policy-card-header-description">
                        For questions or compliance concerns, contact us at <span className={'text-primary'}> <a className={'text-primary'}
                        href={`mailto:${'compliance@advanzinnovation.com'}`}>compliance@advanzinnovation.com.</a></span>
                    </span>
                </div>
                <div className="privacy-policy-card-body">
                    <div className="privacy-policy-card-body-header"></div>

                </div>
            </div>

        </div>
    );
};

export default PrivacyPolicyScreenComponent;
